/**
 * @Author: wuyang
 * @Date: 2024/2/5
 * @Description: ""
 */
import { eventBusService } from '@/common/services/event-bus/eventBusService'
import { message, notification, Progress } from 'antd'
import { useEffect } from 'react'
import { downFile } from '@/utils/downFile'
import { useAtomManagerMethod } from '@/helper/hooks/atom-manager-method-hook/useAtomManagerMethod'

export const Down4KImage = () => {
	const [api, contextHolder] = notification.useNotification({
		top: 60
	})
	const [messageApi, contextHolderMessage] = message.useMessage()
	const [imageData] = useAtomManagerMethod(eventBusService.down4kImageAllMap)

	// 下面监听数组变化的要后面独立抽取 hooks
	useEffect(() => {
		if (!imageData) return
		const { newValue, oldValue, action } = imageData || {}
		if (action === 'updateItem' || action === 'addItem') {
			if (!newValue) return
			if (newValue.progress >= 1) {
				// 触发下载逻辑
				api.destroy(newValue.imageId)
				eventBusService.del4kImage(newValue.imageId)
				messageApi.loading('正在下载 原图分辨率 高清图，请您稍等')
				downFile({
					url: newValue.resImgUrl,
					filename: newValue.resImgUrl.split('/').at(-1)
				}).finally(() => {
					messageApi.destroy()
				})
			} else {
				api.open({
					key: newValue.imageId,
					message: (
						<div
							className={
								'flex justify-between w-full items-center h-[40px] mt-[10px]'
							}
						>
							<div className={'w-[100px] text-[14px] text-subtext text-left'}>
								原图分辨率 图片下载中
							</div>
							<div className={'flex-1'}>
								<Progress
									showInfo={false}
									style={{ marginTop: '10px' }}
									percent={newValue.progress * 100}
									strokeColor={{ '0%': '#108ee9', '100%': '#87d068' }}
								/>
							</div>
							<div className={'w-[50px] text-[14px] text-subtext text-right'}>
								{(newValue.progress * 100).toFixed(0)}%
							</div>
						</div>
					),
					duration: null
				})
			}
		} else if (action === 'delItem') {
			if (!oldValue) return
			api.destroy(oldValue.imageId)
		}
	}, [api, imageData, messageApi])
	return (
		<div>
			{contextHolder}
			{contextHolderMessage}
		</div>
	)
}
